import { render } from "./AdvertisTrade.vue?vue&type=template&id=8765242a&scoped=true&ts=true"
import script from "./AdvertisTrade.vue?vue&type=script&lang=ts"
export * from "./AdvertisTrade.vue?vue&type=script&lang=ts"

import "./AdvertisTrade.vue?vue&type=style&index=0&id=8765242a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8765242a"]])

export default __exports__